import { closeModal, openModal } from '@components/modals';
import { execOnLoad } from '@general/helpers';
import './mobile-menu.scss';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMobileMenu = (context) => {
  const snippetContainer = context.classList.contains('.mobile-menu__container')
    ? context
    : context.closest('.mobile-menu__container');
  if (!snippetContainer) return;
  const header = document.querySelector('.header__background');
  const menuButton = snippetContainer.querySelector('.mobile-menu__icon');
  const modal = snippetContainer.querySelector('.modal');
  if (!menuButton || !modal) return;

  menuButton.addEventListener('click', () => {
    if (modal.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll(
          '.mobile-menu__second-level.open, .mobile-menu__third-level.open',
        )
        .forEach((level) => level.classList.remove('open'));
    } else {
      const announcementHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--announcement-bar-height',
        ),
      );
      if (window.scrollY < announcementHeight)
        window.scrollTo({ top: announcementHeight, behavior: 'smooth' });

      snippetContainer.classList.add('open');
      openModal(modal);
      header.dataset.transparent = 'false';
    }
  });

  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleNavigation = () => {
    if (lgUp.matches && snippetContainer.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll(
          '.mobile-menu__second-level.open, .mobile-menu__third-level.open',
        )
        .forEach((level) => level.classList.remove('open'));
    }
  };
  lgUp.addEventListener('change', handleNavigation);
  snippetContainer
    .querySelectorAll('.mobile-menu__first-level--openable')
    .forEach((firstLevel) => {
      const secondLevel = firstLevel.querySelector(
        '.mobile-menu__second-level',
      );
      const opener = firstLevel.querySelector('.mobile-menu__first-level-link');
      if (!secondLevel || !opener) return;

      opener.addEventListener('click', () => {
        secondLevel.classList.add('open');
        secondLevel
          .querySelectorAll('.mobile-menu__third-level.open')
          .forEach((thirdLevel) => thirdLevel.classList.remove('open'));
      });
    });
  snippetContainer
    .querySelectorAll('.mobile-menu__second-level')
    .forEach((secondLevel) => {
      const back = secondLevel.querySelector('.mobile-menu__back');
      if (back) {
        back.addEventListener('click', () =>
          secondLevel.classList.remove('open'),
        );
      }

      secondLevel
        .querySelectorAll('.mobile-menu__second-level-item--openable')
        .forEach((secondLevelItem) => {
          const thirdLevel = secondLevelItem.querySelector(
            '.mobile-menu__third-level',
          );
          const opener = secondLevelItem.querySelector(
            '.mobile-menu__second-level-link',
          );
          if (!thirdLevel || !opener) return;

          opener.addEventListener('click', () =>
            thirdLevel.classList.add('open'),
          );
        });
    });

  snippetContainer
    .querySelectorAll('.mobile-menu__third-level')
    .forEach((thirdLevel) => {
      const back = thirdLevel.querySelector('.mobile-menu__back');
      if (!back) return;

      back.addEventListener('click', () => thirdLevel.classList.remove('open'));
    });
};

execOnLoad(window.dAgency.initMobileMenu, '.mobile-menu__container');
